require( 'file?name=index.html!index.html' );
require( './library/styles/site.scss' );
require( 'mediators/pm-ui' );



/** WEBPACK FOOTER **
 ** ./browser/spdcalc.js
 **/